import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useNotificationEvents() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.NOTIFICATION_EVENT}/list`,
    { method: 'GET', cacheResponse: true }
  );
}
